module.exports = __webpack_public_path__ + "media/application/images/icons/logo-green-0d8dfcb48008b8b380f2ba45fa818cea.png";